import axios from "axios";
import { useQuery } from "react-query";
import { commonMatrices } from "./logic";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;
axios.defaults.withCredentials = true;

export function postProcessSpectra(obj) {
  return axios.post("/food/view-edit-sample/process-spectra", obj);
}
export function useCommonMatrices(ldate, selectedLocation) {
  return useQuery(["byLoc", "commonMatrices", ldate, selectedLocation], () =>
    commonMatrices(ldate, selectedLocation)
  );
}
